import { useEffect } from "react";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import ShopProductsPanel from "../components/shopOrders/ShopProductsPanel";
import { useDispatch } from "react-redux";
import { setBacklink } from "../redux/backlinkSlice";
import CartButton from "../components/shopOrders/CartButton";
import { Helmet } from 'react-helmet';
import usePageTracking from "../hooks/usePageTracking";

// Questa pagina rileva un eventuale carrello memorizzato in localStorage e se presente lo memorizza in cartSlice
const Shop = () => {

    const { pageTitle, description } = usePageTracking({
        pageTitle: "Shop",
    })

    // Imposto il backlink su "/" in modo che non venga renderizzato
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setBacklink("/"));
    }, [])

    return (
        <PageContainer items="center">
            <Helmet>
                <title>{pageTitle} - TicinoWild</title>
                <meta name="description" content="Scopri l'attrezzatura migliore per le tue avventure outdoor. Zaini, scarpe da trekking, abbigliamento tecnico e accessori per esplorare il Ticino in sicurezza." />
            </Helmet>
            <PageTitle title="Il nostro shop" backLink="/" />
            <CartButton />
            <ShopProductsPanel />
        </PageContainer>
    )
}

export default Shop;